import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function InteractivePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Interactive Group Activities
            </h1>
            <p className="text-xl text-white/95 max-w-3xl mx-auto">
              Engaging interactive games and activities perfect for team building, corporate events, and large gatherings in the Lehigh Valley.
            </p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
              <div>
                <img 
                  src="https://funaffairs.com/wp-content/uploads/2022/11/balloon-1.png"
                  alt="Interactive Group Activities"
                  className="w-full rounded-2xl shadow-2xl"
                />
              </div>
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
                  Bring People Together with Interactive Fun
                </h2>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  Our interactive group activities are designed to engage participants, encourage teamwork, and create memorable experiences. Perfect for corporate team building, school events, festivals, and community gatherings.
                </p>
                <p className="text-base text-gray-600 mb-8 leading-relaxed">
                  From inflatable sports games to interactive challenges, we have activities that accommodate groups of all sizes and ages. Our equipment is safe, well-maintained, and professionally set up by our experienced team.
                </p>
                <Link 
                  to="/contact" 
                  className="inline-block bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap"
                >
                  Get Free Quote
                </Link>
              </div>
            </div>

            <div className="mb-24">
              <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: 'Sora, sans-serif' }}>
                Popular Interactive Activities
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:shadow-xl transition-all">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-basketball-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Inflatable Sports Games</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Interactive sports challenges including basketball shootouts, soccer goals, and more. Great for competitive fun and team building.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:shadow-xl transition-all">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-run-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Obstacle Courses</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Challenging obstacle courses that test agility, speed, and teamwork. Perfect for competitive events and fitness challenges.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:shadow-xl transition-all">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-team-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Team Building Games</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Cooperative activities designed to strengthen teamwork, communication, and problem-solving skills. Ideal for corporate events.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:shadow-xl transition-all">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-trophy-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Competition Challenges</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Head-to-head competitions and timed challenges that bring out everyone's competitive spirit in a fun, safe environment.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-12 text-center">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
                Perfect for Your Next Event
              </h2>
              <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
                Contact Fun Affairs today to discuss interactive group activities for your corporate event, school function, or community gathering.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link 
                  to="/contact" 
                  className="bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  Get Free Quote
                </Link>
                <a 
                  href="tel:6102532835" 
                  className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  <i className="ri-phone-fill mr-2"></i>
                  (610) 253-2835
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}